module.exports = __webpack_public_path__ + "img/img_cemiterio_baixo_e.018f49fb.png";